import React from 'react'
import logo from   '../images/Zing Logo.png'
import sidelogo from '../images/bsnl-logo.jpeg';
import '../App.css';
/* The following line can be included in a src/App.scss */
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
const Header = () => {
  return (
    <div>
       <div className="header mobilehead">
        <Row>
         <Col xs={4} md={4} sm={4} lg={4}>

          <img src={logo} className='logo_img' alt='logo'/>
          </Col>

          <Col xs={4} md={4} sm={4} lg={4} >

            <h4 className='head_name'>BI Reporting System</h4>
            </Col>
            <Col xs={4} md={4} sm={4} lg={4} className='d-flex justify-content-end'>

        <img src={sidelogo} className='side_img ' alt='logoside'/>
        </Col>

         </Row>
    </div>
    </div>
  )
}

export default Header
